// Mirror di oniri-viewer-api/src/errors.ts ERROR_CODES.
// MAI cambiare un code esistente, solo aggiungere nuovi (vedi commento backend).
export type ErrorCode =
  | 'unauthorized'
  | 'forbidden'
  | 'not_found'
  | 'gone_expired'
  | 'conflict_max_presets'
  | 'rate_limited'
  | 'invalid_payload'
  | 'invalid_format'
  | 'internal_error'
  // Phase 9 SEZ 5 device tracking:
  | 'device_required'
  | 'device_revoked'
  // Phase 10 Task 1.2 auth endpoints:
  | 'email_already_exists'
  | 'email_not_verified'
  | 'account_suspended'
  | 'invalid_credentials'
  | 'token_invalid'
  // Phase 10 Task 8 legacy migration:
  | 'legacy_auth_expired'
  | 'already_migrated'
  | 'studio_missing_contact_email';

const TERMINAL_CODES: ReadonlySet<ErrorCode> = new Set([
  'not_found',
  'gone_expired',
  'unauthorized',
  'forbidden',
  'invalid_payload',
  'invalid_format',
  'conflict_max_presets',
]);

const RETRYABLE_CODES: ReadonlySet<ErrorCode> = new Set(['rate_limited', 'internal_error']);

export function isTerminalCode(code: ErrorCode): boolean {
  return TERMINAL_CODES.has(code);
}

export function isRetryableCode(code: ErrorCode): boolean {
  return RETRYABLE_CODES.has(code);
}
